import { clientEnvIsLinux } from "./isLinux";
import { clientEnvIsDesktop } from "./isDesktop";

export const clientEnvIsLinuxBrowser = (): boolean => {
  return clientEnvIsLinux() && !clientEnvIsDesktop();
};
